import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['profile', 'insufficientBalance', 'sufficientBalance'];
  static values = { membershipPrice: Number };

  connect() {
    this.profileTarget.click();
  }

  toggle(e) {
    const profileCurrentBalance = e.currentTarget.dataset.currentBalance;
    if (this.membershipPriceValue > profileCurrentBalance) {
      this.insufficientBalanceTarget.hidden = false;
      this.sufficientBalanceTarget.hidden = true;
    } else {
      this.insufficientBalanceTarget.hidden = true;
      this.sufficientBalanceTarget.hidden = false;
    }
  }
}
